export enum NavMenuLinks {
  HOME = '/',
  PLEX = '/zee-plex-movies-on-rent',
  PREMIUM = '/premium',
  FREE_MOVIES = '/free-movies',
  TV_SHOWS = '/tv-shows',
  MOVIES = '/movies',
  SPORTS = '/cricket/ilt20',
  ILT_20 = '/sports/cricket/ilt20',
  LEARNING = '/eduauraa',
  KIDS = '/kids',
  MUSIC = '/music-videos',
  LIVE_TV = '/live-tv',
  VIDEOS = '/videos',
  NEWS = '/news',
  WEBSERIES = '/web-series',
  UPCOMING = '/upcoming',
  TV_CHANNELS = '/tv-shows/tv-channels',
  STORIES = '/stories',
  ARTICLES = '/articles',
  PLAY5 = '/play5-games',
  GAME_ROUTE = '/sports/games'
}

export enum Routes {
  B2B_LIVE_TV = 'b2b-live-tv'
}
export enum HeaderLinks {
  SIGN_IN = '/signin?redirectFromWebApp=1',
  REGISTER = '/register?redirectFromWebApp=1'
}

export enum ProfileMenuLinks {
  MY_PROFILE = '/myprofile',
  WATCH_LIST = '/myprofile/watchlist',
  PLANS = '/myprofile/plans',
  RENTALS = '/myprofile/rentals',
  PAYMENTS = '/myprofile/payments',
  MANAGE_DEVICES = '/myprofile/managedevices',
  LEADERBOARD_LINK = '/myprofile/leaderboard',
  USREFERRAL = '/USReferral',
  LOGOUT_LINK = '/logout'
}

export enum HamburgerMenuLinks {
  BUY_PLAN = '/myaccount/subscription',
  ABOUT_US = '/aboutus',
  TERMS = '/termsofuse',
  POLICY = '/privacypolicy',
  HOWTOPLAY = '/howtoplay',
  RESET_SETTINGS = '/resetdefault',
  CONTENT_REDRESSAL_MECHANISM = 'https://helpcenter.zee5.com/portal/en/kb/articles/content-grievance-redressal',
  FAQ = 'https://www.zee5.com/help/',
  PARENTAL_CONTROL = '/parentalcontrol',
  NFT = '/nft',
  AUTH_DEVICE = '/device',
  STUDENT = '/student',
  LANGUAGE = '/language',
  REFERRAL_ROUTE = '/referral',
  CONSENT_SETTINGS = '/cookiesconsent',
  BLOG = '/blog/',
  GAMIFICATION_ROUTE = '/gamification/watchandwin',
  WATCH_AND_WIN_TERMS_AND_CONDITIONS_PAGE = '/watch-live-win-terms-and-conditions',
  WATCH_AND_WIN_HOW_TO_PLAY_PAGE = '/watch-live-win-big-how-to-play',
  WATCH_AND_WIN_PRIVACY_POLICY_PAGE = '/watch-live-win-privacy-policy'
}

export const NOT_FOUND = '/notFound';

export const COLLECTIONS_URL = '/collections';
export const OLD_CHANNELCONSUMPTION_PATH = '/channels/details/';

export const ADD_ONS = '/add-ons';
export const GLOBAL = '/global';

export const PARTNER_SUBSCRIPTION = '/myaccount/partnersubscriptions';

export const GENRE_LINK = '/genre';
